import React, { useState, useCallback } from 'react';
import './GradientPage.css';

interface GradientPageProps {
  isVisible: boolean;
}

interface ColorOption {
  id: number;
  name: string;
  color: string;
  gradient: string;
}

const GradientPage: React.FC<GradientPageProps> = ({ isVisible }) => {
  const [selectedColor, setSelectedColor] = useState(0);

  const colorOptions: ColorOption[] = [
    {
      id: 0,
      name: '黒',
      color: '#000000',
      gradient: 'linear-gradient(135deg, #000000 0%, #1a1a1a 50%, #333333 100%)'
    },
    {
      id: 1,
      name: 'うす紫',
      color: '#9966cc',
      gradient: 'linear-gradient(135deg, #6a4c93 0%, #9966cc 50%, #c9a9dd 100%)'
    },
    {
      id: 2,
      name: 'ダークブルー',
      color: '#1e3a8a',
      gradient: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 50%, #3b82f6 100%)'
    }
  ];

  const handleColorChange = useCallback((index: number) => {
    setSelectedColor(index);
  }, []);

  return (
    <div 
      className={`gradient-page-container ${isVisible ? 'visible' : ''}`}
      style={{ background: colorOptions[selectedColor].gradient }}
    >
      {/* ページタイトル */}
      <div className="page-title-container">
        <h2 className="page-title">グラデーションページ</h2>
      </div>

      {/* メインコンテンツエリア */}
      <div className="gradient-content">
        {/* スライドボタンコンテナ */}
        <div className="slide-buttons-container">
          <div className="slide-buttons">
            {colorOptions.map((option, index) => (
              <button
                key={option.id}
                className={`slide-button ${index === selectedColor ? 'active' : ''}`}
                onClick={() => handleColorChange(index)}
                style={{
                  backgroundColor: option.color,
                  boxShadow: index === selectedColor 
                    ? `0 0 20px ${option.color}40` 
                    : 'none'
                }}
              >
                {option.name}
              </button>
            ))}
          </div>
          
          {/* アクティブインジケーター */}
          <div 
            className="active-indicator"
            style={{
              left: `${(selectedColor * 100) / colorOptions.length}%`,
              backgroundColor: colorOptions[selectedColor].color
            }}
          />
        </div>

        {/* カラー情報表示 */}
        <div className="color-info">
          <div className="color-preview">
            <div 
              className="color-circle"
              style={{ background: colorOptions[selectedColor].gradient }}
            />
            <div className="color-details">
              <h3 className="color-name">{colorOptions[selectedColor].name}</h3>
              <p className="color-code">{colorOptions[selectedColor].color}</p>
            </div>
          </div>
        </div>

        {/* 装飾的な要素 */}
        <div className="decorative-elements">
          {Array.from({ length: 5 }, (_, i) => (
            <div
              key={i}
              className="floating-orb"
              style={{
                left: `${20 + i * 15}%`,
                animationDelay: `${i * 0.8}s`,
                background: `radial-gradient(circle, ${colorOptions[selectedColor].color}40, transparent)`
              }}
            />
          ))}
        </div>
      </div>

      {/* 背景パーティクル */}
      <div className="background-particles">
        {Array.from({ length: 20 }, (_, i) => (
          <div
            key={i}
            className="particle"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 5}s`,
              backgroundColor: colorOptions[selectedColor].color
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default GradientPage;